module.exports = __webpack_public_path__ + "assets/img/cs-square.9b000156.jpg";